import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { IncomePaymentDestination } from "../../../../../../Wrap/Constants/Enums/Domain/IncomePaymentDestination";
import { Money } from "../../../../../../Wrap/Core/DataTypes/Money";
import { DrawdownPaymentDestinationAllocation } from "../../../../../../Wrap/Models/Domains/Drawdown/DrawdownPaymentDestinationAllocation";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { Typography } from "../../../../../Shared/Typography/Typography";
import { PensionContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";

interface IReviewProps extends IProcessComponentProps {
    data: PensionContributionModel;
    customerId?: number;
    extraInfo?: any
}

interface IReviewState {}

export class IncomePaymentOneOffReview extends ProcessComponent<IReviewProps, IReviewState> {
    constructor(props: any) {
        super(props);       
    } 

    private clientDetailRender() {
        const {
            Payment,
            DisinvestmentAllocations,
        } = this.props.data?.Contribution?.OneOffIncomePaymentModel?.Instruction;
        const {
            CashAvailable,
            CashInstrument,
            EstimatedAssetValueAvailable,
            TotalEstimatedValueAvailable,
        } = this.props.data?.Contribution?.OneOffIncomePaymentModel;

        const paymentAmount: Money = Payment.Amount ?? { Amount: 0, Currency: CurrencyCode.GBP };
        const nonCashAllocations =
            DisinvestmentAllocations?.filter((x) => x.ProductId != CashInstrument.ProductId) ?? [];

        const config = [
            {
                title: "Payment amount",
                data: MoneyDisplayHelper.getMoneyFormat(paymentAmount),
            },
            {
                title: "Payment type",
                data: nonCashAllocations.length == 0 ? "Available cash" : "Assets and available cash",
            },
        ];

        const destinationAllocationsToArray = Object.values(Payment.PaymentDestinationAllocations);

        if (destinationAllocationsToArray.length != 0) {
            if (destinationAllocationsToArray.length == 1) {
                config.push({
                    title: "Bank account",
                    data: this.getDestinationDescription(destinationAllocationsToArray[0]),
                });
            } else {
                destinationAllocationsToArray.map((ele, index) => {
                    config.push(
                        {
                            title: "Bank account " + (index + 1),
                            data: this.getDestinationDescription(ele),
                        },
                        {
                            title: "Proportion " + (index + 1),
                            data: ele.Allocation + "%",
                        }
                    );
                });
            }
        }

        const fromAssets = nonCashAllocations.filter(item => item.Value).reduce((total, el) => total + el.Value.Amount, 0);
        const assetRemaining: Money = {
            Amount: EstimatedAssetValueAvailable.Amount - fromAssets,
            Currency: EstimatedAssetValueAvailable.Currency,
        };
        const cashRemaining: Money = {
            Amount: CashAvailable.Amount - paymentAmount.Amount + fromAssets,
            Currency: CashAvailable.Currency,
        };
        const totalRemaining: Money = {
            Amount: TotalEstimatedValueAvailable.Amount - paymentAmount.Amount,
            Currency: TotalEstimatedValueAvailable.Currency,
        };

        config.push(
            {
                title: "Estimated cash remaining",
                data: MoneyDisplayHelper.getMoneyFormat(cashRemaining),
            },
            {
                title: "Estimated asset value remaining",
                data: MoneyDisplayHelper.getMoneyFormat(assetRemaining),
            },
            {
                title: "Estimated total value remaining",
                data: MoneyDisplayHelper.getMoneyFormat(totalRemaining),
            }
        );

        return (
            <div>
                <div className="d-flex flex-space">
                    <h2 className="mb-11">Income payment details</h2>
                </div>

                <hr className="heading-underlined-text"></hr>
                <Typography type="common" config={config}></Typography>
            </div>
        );
    }

    private getDestinationDescription(destination: DrawdownPaymentDestinationAllocation): string {
        if (destination.Destination == IncomePaymentDestination.WrapCash) {
            return "Cash Account";
        }

        const allBankAccounts = this.props.extraInfo?.AllBankAccounts ?? [];
        const bankAccountInstructions = this.props.data?.BankAccountInstructions ?? [];
        const bankAccount = allBankAccounts.find((x) => x?.BankAccountId === destination.BankAccountId) ||
        bankAccountInstructions.find((x) => x?.Id === destination.BankAccountId);

        return (
            (bankAccount?.AccountNumber ?? "") + " " +
            (bankAccount?.BankCodes?.BankCode ?? "") + "-" +
            (bankAccount?.BankCodes?.BranchCode ?? "") + "-" +
            (bankAccount?.BankCodes?.ExtraCode ?? "") + " " +
            (bankAccount?.AccountName ?? "")
        );
    }

    render() {
        return (
            <>
                <h2 className="mb-24">Review</h2>                
                {this.clientDetailRender()}                
            </>
        );
    }
}
